import api from "./api";

export async function getDivision(divisionId, value) {
  const { data: divisions } = await api.get("/api/v1/divisions", {
    params: { eons: true, search: value },
    limit: 100,
  });
  return divisions;
}
